export function initialize() {
  // Modaal
  // http://humaan.com/modaal/
  // ----------------------------------------------------------------------------

  $('.lead-gen-modal-trigger').modaal({
    width: 1218
  })

  $('.cta-modal-trigger').modaal({
    width: 1218
  })

  $('.cta-phone-trigger').modaal()
}
